export const getStatusNumber = (reason) => {
	return {
		AR: {
			100: 'Recordá que en la reserva de un medicamento bajo receta tenés que verificar los datos de la cobertura de salud junto con la receta médica. Cuando le des a continuar se le enviará un link de pago al cliente.',
			200: 'Esperando el pago del cliente. Si el pago se procesa con éxito la reserva cambiará a completada, caso contrario será rechazada.',
			300: `La reserva fue rechazada por: ${reason}.`,
			400: 'El cliente ha pagado su reserva. Seguí el proceso de la orden en Aprobada.',
		},

		CL: {
			100: 'Antes de aprobar la solicitud, verifica los datos. También puedes rechazarla desde aqui.',
			200: 'La solicitud ha sido aprobada y se le ha enviado el mail al cliente para completar la orden.',
			300: `La solicitud fue rechazada por: ${reason}.`,
			400: 'El cliente ya pagó su solicitud. Puedes hacer seguimiento de la orden desde órdenes de compra.',
		},
		CLNARMA: {
			100: 'Antes de aprobar la solicitud, verifica los datos. También puedes rechazarla desde aqui.',
			200: 'La solicitud ha sido aprobada y se le ha enviado el mail al cliente para completar la orden.',
			300: `La solicitud fue rechazada por: ${reason}.`,
			400: 'El cliente ya pagó su solicitud. Puedes hacer seguimiento de la orden desde órdenes de compra.',
		},
		CLGREEN: {
			100: 'Antes de aprobar la solicitud, verifica los datos. También puedes rechazarla desde aqui.',
			200: 'La solicitud ha sido aprobada y se le ha enviado el mail al cliente para completar la orden.',
			300: `La solicitud fue rechazada por: ${reason}.`,
			400: 'El cliente ya pagó su solicitud. Puedes hacer seguimiento de la orden desde órdenes de compra.',
		},
		CLZUPHARMA: {
			100: 'Antes de aprobar la solicitud, verifica los datos. También puedes rechazarla desde aqui.',
			200: 'La solicitud ha sido aprobada y se le ha enviado el mail al cliente para completar la orden.',
			300: `La solicitud fue rechazada por: ${reason}.`,
			400: 'El cliente ya pagó su solicitud. Puedes hacer seguimiento de la orden desde órdenes de compra.',
		},
		MX: {
			100: 'Antes de aprobar la solicitud, verifica los datos. También puedes rechazarla desde aqui.',
			200: 'La solicitud ha sido aprobada y se le ha enviado el mail al cliente para completar la orden.',
			300: `La solicitud fue rechazada por: ${reason}.`,
			400: 'El cliente ya pagó su solicitud. Puedes hacer seguimiento de la orden desde órdenes de compra.',
		},
	};
};
